module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 4.66c52221.png";